import type { ReadonlyDeep, WritableDeep } from "type-fest";

import { clone as ramdaClone } from "ramda";

function awaitTimeout(delay: number) {
  return new Promise((resolve) => setTimeout(resolve, delay));
}

function arrayWrap<Value>(value: Value) {
  if (Array.isArray(value)) {
    return value as Extract<Value, unknown[] | readonly unknown[]>;
  }
  return [value] as Exclude<
    Exclude<Value, unknown[] | readonly unknown[]>[],
    never[]
  >;
}

const clone = ramdaClone as <Param>(
  param: ReadonlyDeep<Param>,
) => WritableDeep<Param>;

export * from "./currency.enum.ts";
export * from "./currency.ts";
export * from "./dayjs.ts";
export * from "./decodeHtml.ts";
export * from "./deepToString.ts";
export * from "./errorHandling.ts";
export * from "./isEqual.ts";
export * from "./memoize.ts";
export * from "./networkErrorHandling.ts";
export * from "./sentryClient.ts";
export * from "./solvariEnv.ts";
export * from "./solvariEnvTestDefault.ts";
export * from "./throttleable.ts";
export * from "./toSearchParams.ts";
export type * from "./types.ts";
export { arrayWrap, awaitTimeout, clone };
